import React from 'react';
import { MeinBereichButton, MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { enumT } from '../../../../utils/helper';

function VorDerForderung() {
	const navigate = useNavigate();
	return (
		<>
			<MeinBereichPaper titleIcon={<EditIcon />} title={'Vor der Förderung'}>
				<MeinBereichButton
					buttonName="Neuen Antrag einreichen"
					onClick={() => {
						navigate(`/foerderprogramm`);
					}}
				/>
				<MeinBereichButton
					buttonName="Einen Antrag bearbeiten"
					onClick={() => {
						navigate(`/meine-antraege`, {
							state: {
								filter: {
									field: 'Antragsstatus_Antragsstatus',
									operator: 'contains',
									value: enumT('inBearbeitung'),
								},
							},
						});
					}}
				/>
				<MeinBereichButton
					buttonName="Eingereichte Anträge ansehen"
					onClick={() => {
						navigate(`/meine-antraege`, {
							state: {
								filter: {
									field: 'Antragsstatus_Antragsstatus',
									operator: 'contains',
									value: enumT('eingegangen'),
								},
							},
						});
					}}
				/>
			</MeinBereichPaper>
		</>
	);
}

export default VorDerForderung;
